import { hslToRgbObj } from "./UTILS";

// PALETTE MAKER
export const createPixelPortraitPalette = ({
  baseHue = 0,
  baseSaturation = 50,
  totalColours = 10,
  labels,
  isStickerVersion,
  customHues = [
    52, 52, 52, 52, 52, 52, 52, 52, 140, 140, 140, 140, 140, 140, 140, 140,
  ],
}) => {
  const brightnessBandSize = 100 / (totalColours - 1);
  const swatches = [];
  const symbols = []; //["", "O", "X", "#", "=", "M", "%", "&"];

  for (let i = 0; i < totalColours; i++) {
    const lightness = Math.round(100 - brightnessBandSize * i);
    const greyRGB = hslToRgbObj(0, 100, lightness);
    // use a number if the symbol doesn't exist
    const symbol = i < symbols.length ? symbols[i] : i + 1;

    const customHue = customHues[i] ? customHues[i] : null;

    swatches.push({
      greyRGB,
      hue: baseHue,
      saturation: baseSaturation,
      lightness,
      isStickerVersion,
      symbol,
      customHue,
    });
  }

  return {
    baseHue,
    baseSaturation,
    totalColours,
    swatches,
    labels,
  };
};

/* Extended Array */
// red to green palette
// const colours = [
//   [50, 100, 49],
//   [51, 100, 47],
//   [53, 99, 46],
//   [54, 99, 44],
//   [56, 98, 42],
//   [58, 98, 40],
//   [61, 97, 38],
//   [63, 97, 38],
//   [65, 97, 37],
//   [68, 96, 37],
//   [71, 96, 36],
//   [73, 95, 36],
//   [76, 94, 35],
//   [79, 94, 35],
//   [82, 93, 34],
//   [85, 93, 34],
//   [89, 92, 34],
//   [92, 92, 33],
//   [96, 90, 33],
//   [99, 90, 32],
// ];
